export class PopoverScripts {
   static getPopoverCoordinates = (finalPlacement, childBCRect, popoverElement) => {
      let coordinates = { left: 0, top: 0 };
      if (childBCRect?.x && finalPlacement) {
         switch (finalPlacement) {
            case "top":
               coordinates = {
                  left: childBCRect.x + childBCRect.width / 2 - popoverElement.offsetWidth / 2,
                  top: childBCRect.y - popoverElement.offsetHeight - 10
               };
               break;
            case "bottom":
               coordinates = {
                  left: childBCRect.x + childBCRect.width / 2 - popoverElement.offsetWidth / 2,
                  top: childBCRect.y + childBCRect.height + 10
               };
               break;
            case "right":
               coordinates = {
                  left: childBCRect.x + childBCRect.width + 10,
                  top: childBCRect.y + childBCRect.height / 2 - popoverElement.offsetHeight / 2
               };
               break;
            case "left":
               coordinates = {
                  left: childBCRect.x - popoverElement.offsetWidth - 10,
                  top: childBCRect.y + childBCRect.height / 2 - popoverElement.offsetHeight / 2
               };
               break;
         }
      }
      return coordinates;
   };
   static fixOutOfScreenPlacement = (initialPlacement, position, currentPopover) => {
      let finalPlacement = initialPlacement;
      if (initialPlacement === "left" || initialPlacement === "right") {
         if (position.left + currentPopover.offsetWidth >= window.innerWidth) {
            finalPlacement = "left";
         }
         if (position.left < 0) {
            finalPlacement = "right";
         }
      }
      if (initialPlacement === "top" || initialPlacement === "bottom") {
         if (position.top + currentPopover.offsetHeight > window.innerHeight) {
            finalPlacement = "top";
         }
         if (position.top < 0) {
            finalPlacement = "bottom";
         }
      }
      return finalPlacement;
   };
   static fixOutOfScreenCoordinates = (finalPosition, currentPopover) => {
      let leftPosition = finalPosition.left;
      let topPosition = finalPosition.top;
      if (leftPosition < 0) {
         leftPosition = 3;
      } else if (leftPosition + currentPopover.offsetWidth >= window.innerWidth) {
         leftPosition = window.innerWidth - currentPopover.offsetWidth - 3;
      }
      if (topPosition < 0) {
         topPosition = 3;
      } else if (topPosition + currentPopover.offsetHeight >= window.innerHeight) {
         topPosition = window.innerHeight - currentPopover.offsetHeight - 3;
      }
      return { left: leftPosition, top: topPosition };
   };
   static getArrowCoordinates = (finalPlacement, popoverElement) => {
      let arrowCoordinates;
      switch (finalPlacement) {
         case "right":
            arrowCoordinates = {
               top: popoverElement.height / 2 || 0
            };
            break;
         case "left":
            arrowCoordinates = {
               bottom: popoverElement.height / 2 || 0
            };
            break;
         case "top":
            arrowCoordinates = {
               left: popoverElement.width / 2 || 0
            };
            break;
         case "bottom":
            arrowCoordinates = {
               right: popoverElement.width / 2 || 0
            };
            break;
      }
      return arrowCoordinates;
   };
}
